module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"locationNotfound":"この住所からは有効な所在地が特定できませんでした。","withinKmRadius":"{distance}km以内"}}')
  delete Component.options._Ctor
}
